
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="max-w-md w-full mx-auto p-8 text-center border border-gray-200 rounded-lg shadow-sm">
        <h1 className="text-3xl font-bold mb-4">404: NOT_FOUND</h1>
        <p className="text-gray-700 mb-2">
          Code: <code className="bg-gray-100 px-1 py-0.5 rounded">NOT_FOUND</code>
        </p>
        <p className="text-gray-700 mb-6">
          ID: <code className="bg-gray-100 px-1 py-0.5 rounded">frai::dzrdq-{Math.floor(Math.random() * 10000000)}-d2fdaf5989c9</code>
        </p>
        
        <Link to="/" className="inline-block px-6 py-3 bg-blue-500 hover:bg-blue-600 text-white rounded-md transition-colors mb-4">
          Return to Homepage
        </Link>
        
        <p className="text-sm text-gray-500">
          <img 
            src="/lovable-uploads/600e2cf1-a58f-4653-b838-90b53e2c276f.png" 
            alt="Error screen reference" 
            className="hidden"
          />
        </p>
      </div>
    </div>
  );
};

export default NotFound;
